import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import i18n from '@/i18n'
import { getAppParams, initAppParams } from '@/stores/app'
import { detectLanguage, setLanguage } from '@/i18n'
import { initRNListener, installRouterBridge } from '@/bridge'

import 'vant/lib/index.css'
import './styles/vant.css'
import './index.css'

async function bootstrap(): Promise<void> {
  // 原生参数是嵌入模式的权威登录态，必须在 Vue Router 开始首个导航前完成初始化。
  initAppParams()
  try {
    await setLanguage(detectLanguage(getAppParams().language))
  } catch (error) {
    // 语言包加载失败不应阻断应用挂载，继续使用已注册的默认语言。
    console.warn('[bootstrap] language initialization failed', error)
  }

  const app = createApp(App)
  app.use(i18n)
  app.use(router)

  // 全局错误兜底（async / 事件处理器错误，onErrorCaptured 不覆盖这些）。
  app.config.errorHandler = (err) => {
    console.error('[app errorHandler]', err)
  }

  initRNListener()
  installRouterBridge(router)
  app.mount('#app')
}

void bootstrap()
